import { render, staticRenderFns } from "./Recalculation.vue?vue&type=template&id=1674cd7d&scoped=true&"
import script from "./Recalculation.vue?vue&type=script&lang=js&"
export * from "./Recalculation.vue?vue&type=script&lang=js&"
import style0 from "./Recalculation.vue?vue&type=style&index=0&id=1674cd7d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1674cd7d",
  null
  
)

export default component.exports